import { StateCreator } from "zustand";

export type TTeamPerfReportsFilters = {
  startDate: string;
  endDate: string;
  periodValue?: string;
  dateType?: string;
  campaignName?: string;
  supervisorName?: string;
  rank?: string;
};

export type TTeamPerfReportsStore = {
  teamPerfReportsFilters: TTeamPerfReportsFilters;
  setTeamPerfReportsFilters: (
    filters:
      | TTeamPerfReportsFilters
      | ((prev: TTeamPerfReportsFilters) => TTeamPerfReportsFilters),
  ) => void;
  supervisorTeamPerfReportsFilters: TTeamPerfReportsFilters;
  setSupervisorTeamPerfReportsFilters: (
    filters:
      | TTeamPerfReportsFilters
      | ((prev: TTeamPerfReportsFilters) => TTeamPerfReportsFilters),
  ) => void;
};

export const createTeamPerformanceReportsSlice: StateCreator<
  TTeamPerfReportsStore,
  [],
  [],
  TTeamPerfReportsStore
> = (set) => ({
  teamPerfReportsFilters: {
    startDate: "",
    endDate: "",
    periodValue: "last-week",
    dateType: "call_date",
    campaignName: "",
    rank: "",
  },
  setTeamPerfReportsFilters: (filters) =>
    set((state) => ({
      teamPerfReportsFilters:
        typeof filters === "function"
          ? filters(state.teamPerfReportsFilters)
          : filters,
    })),
  supervisorTeamPerfReportsFilters: {
    startDate: "",
    endDate: "",
    periodValue: "last-week",
    dateType: "call_date",
    supervisorName: "",
    rank: "",
  },
  setSupervisorTeamPerfReportsFilters: (filters) =>
    set((state) => ({
      supervisorTeamPerfReportsFilters:
        typeof filters === "function"
          ? filters(state.supervisorTeamPerfReportsFilters)
          : filters,
    })),
});
